// CORE

function tabOutline() {
  const siteBody = document.querySelector('[data-site-body]');

  document.addEventListener('keydown', (event) => {
    if (event.keyCode !== 9) { return; }
    siteBody.classList.add('tab-outline');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  focusHash();
  bindInPageLinks();
  tabOutline();
});

function objectFitFallback() {
  // Detect objectFit support
  if ('objectFit' in document.documentElement.style !== false) { return; }

  const coverImages = document.querySelectorAll('.img-cover');
  const containImages = document.querySelectorAll('.img-contain');

  handleObjectFit(coverImages, 'cover');
  handleObjectFit(containImages, 'contain');

  function handleObjectFit(items, type) {
    if (items === null) { return; }

    items.forEach(item => {
      const itemImage = item.querySelector('img');
      itemImage.style.display = 'none';
      item.classList.add('no-object-fit', `no-object-fit--${type}`);
      item.style.backgroundSize = type;
      item.style.backgroundImage = `url(${itemImage.src})`;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  objectFitFallback();
});

function drawers() {
  const drawerLeft = document.querySelector('[data-drawer-left]');
  const drawerToggles = document.querySelectorAll('[data-drawer-toggle]');
  const drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');
  const siteHtml = document.querySelector('[data-site-html]');
  const siteBody = document.querySelector('[data-site-body]');
  const siteOverlay = document.querySelector('[data-site-overlay]');

  if (!drawerLeft) { return; }

  drawerToggles.forEach((drawerToggle) => {
    drawerToggle.addEventListener('click', () => {
      drawerLeft.classList.add('active');
      trapFocus(drawerLeft);

      siteHtml.classList.add('drawer-active');
      siteBody.classList.add('drawer-active');
      siteOverlay.classList.add('active');
    });
  });

  drawerCloseButtons.forEach((drawerCloseButton) => {
    drawerCloseButton.addEventListener('click', () => {
      closeDrawer();
    });
  });


  document.addEventListener('keydown', (event) => {
    if (event.keyCode !== 27) { return; }
    closeDrawer();
  });

  siteOverlay.addEventListener('click', () => {
    closeDrawer();
  });

  function closeDrawer() {
    drawerLeft.classList.remove('active');
    siteHtml.classList.remove('drawer-active');
    siteBody.classList.remove('drawer-active');
    siteOverlay.classList.remove('active');
    removeTrapFocus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  drawers();
});


/*
*
*   To add form validation:
*   - Give form [data-validation-required]
*   - Wrap required field with [data-required-field-wrapper]
*   - Give required field [data-required-field="value"] with value set to the desired error message
*   - Add a span inside the wrapper with the desired error icon/text to display on input (example: <span>&times;</span>)
*
*   Optional:
*   - to add further validation (by default validation checks if field is empty)
*     set [data-required-field="some-regex-here"] on required field with desired regex validation
*
*/

function requiredValidation() {
  const forms = document.querySelectorAll('[data-validation-required]');

  if (!forms.length) { return; }

  forms.forEach((form) => {
    const requiredFields = form.querySelectorAll('[data-required-field]');

    form.setAttribute('novalidate', 'novalidate');
    // eslint-disable-next-line shopify/prefer-early-return
    form.addEventListener('submit', (event) => {
      if (form.getAttribute('data-validation-required') !== 'false') {
        event.preventDefault();

        requiredFields.forEach((field) => {
          validate(field);

          field.addEventListener('input', () => {
            validate(field);
          });
        });

        if (!checkForErrors(requiredFields)) {
          if (form.getAttribute('data-ajax-submit') === null) {
            form.submit();
          } else {
            form.setAttribute('data-validation-required', 'false');
            if (!form.hasAttribute('data-request-quote-form')) {
              setTimeout(() => {
                form.querySelector('button[type="submit"]').click();
              }, 500);
            }
          }
        }
      }
    });
  });
}

function validate(field) {
  const pattern = field.getAttribute('data-required-field-pattern');
  const errorMessage = field.getAttribute('data-required-field');

  if (pattern) {
    const regex = new RegExp(pattern);

    if (field.value.length === 0) {
      addErrorMessage(field, 'required field');
    } else if (regex.test(field.value)) {
      field.classList.remove('input-error');
    } else {
      addErrorMessage(field, errorMessage);
    }
  } else if (field.value.length > 0) {
    field.classList.remove('input-error');
  } else {
    addErrorMessage(field, errorMessage);
  }
}

function checkForErrors(fields) {
  let errors = false;

  fields.forEach((field) => {
    if (field.classList.contains('input-error')) {
      errors = true;
    }
  });

  return errors;
}

function addErrorMessage(field, errorMessage) {
  field.classList.add('input-error');
  field.nextElementSibling.setAttribute('data-after', errorMessage === '' ? 'required field' : errorMessage);
}

document.addEventListener('DOMContentLoaded', () => {
  requiredValidation();
});

document.addEventListener('shopify:section:load', () => {
  requiredValidation();
});


function desktopHeaderScrollDirection() {
  const bodyTag = document.querySelector('[data-site-body]');
  const promoBar = document.querySelector('[data-promo-bar]');
  let lastScrollTop = 0;
  let lastDownScroll = 0;

  function handleWindowScroll() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    const disableAt = (bodyTag.classList.contains('promo-bar-active')) ? promoBar.offsetHeight + 100 : 100;

    // Activate a bit down the page
    if (st > lastScrollTop && st > 50) {
      // downscroll
      bodyTag.classList.add('scroll-down');
      bodyTag.classList.remove('scroll-up');
      lastDownScroll = st;
    } else if (st < lastScrollTop && st > disableAt) {
      // upscroll
      if (st < (lastDownScroll - 150)) {
        bodyTag.classList.remove('scroll-down');
        bodyTag.classList.add('scroll-up');
      }
    } else {
      bodyTag.classList.remove('scroll-down', 'scroll-up');
    }
    lastScrollTop = st <= 0 ? 0 : st;

    if (window.pageYOffset > 750) {
      bodyTag.classList.add('scroll-down-hide');
    } else {
      bodyTag.classList.remove('scroll-down-hide');
    }
  }

  window.addEventListener('scroll', handleWindowScroll, false);
}

document.addEventListener('DOMContentLoaded', () => {
  desktopHeaderScrollDirection();
});

// HEADER 

function headerSearch() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchBar = document.querySelector('[data-search-bar]');
  const searchCloseBtn = document.querySelector('[data-header-search-close]');
  const searchInput = document.querySelector('[data-search-bar-input]');

  searchToggle.addEventListener('click', () => {
    searchBar.classList.add('active');
    searchInput.focus();
  });

  searchCloseBtn.addEventListener('click', closeSearchBar);

  function closeSearchBar() {
    searchBar.classList.remove('active');
    searchInput.blur();
  }

  searchInput.addEventListener('keydown', (event) => {
    if (event.keyCode !== 27) { return; }
    closeSearchBar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  headerSearch();
});

document.addEventListener('shopify:section:load', () => {
  headerSearch();
});

// NAV 

function navInit() {
  const nav = document.querySelector('[data-desktop-nav]');
  const overlay = document.querySelector('[data-nav-overlay]');
  if (!nav || !overlay) { return; }

  const collectionLinks = nav.querySelectorAll('[data-collection-link]');
  const productLists = nav.querySelectorAll('[data-products-list]');
  const triggers = nav.querySelectorAll('[data-nav-trigger]');

  collectionLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      makeLinkActive(link);
    });

    link.addEventListener('focus', () => {
      makeLinkActive(link);
    });
  });

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => {
      overlay.classList.add('open');
      const triggerCollectionLinks = trigger.querySelectorAll('[data-collection-link]');
      if (triggerCollectionLinks.length === 0) { return; }
      makeLinkActive(triggerCollectionLinks[0]);
    });

    trigger.addEventListener('mouseleave', () => {
      overlay.classList.remove('open');
    });
  });

  function makeLinkActive(link) {
    collectionLinks.forEach((collectionLink) => {
      collectionLink.classList.remove('active-link');
    });
    link.classList.add('active-link');

    const targetString = link.getAttribute('data-collection-link');
    const targetList = nav.querySelector(`[data-products-list--${targetString}]`);
    if (!targetList) { return; }

    productLists.forEach((list) => {
      list.classList.add('hide');
    });
    targetList.classList.remove('hide');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  navInit();
});

// MOBILE NAV

function mobileNav() {
  const submenus = document.querySelectorAll('[data-mobile-nav-submenu]');
  const submenuOpenButtons = document.querySelectorAll('[data-mobile-nav-submenu-open]');
  const submenuCloseButtons = document.querySelectorAll('[data-mobile-nav-submenu-close]');

  if (!submenus.length) { return; }

  submenuOpenButtons.forEach((submenuOpenButton, i) => {
    submenuOpenButton.addEventListener('click', () => {
      submenus.forEach((submenu, j) => {
        submenus[j].classList.add('hide');
        submenuOpenButtons[j].classList.remove('hide');
        submenuCloseButtons[j].classList.add('hide');
      });

      submenus[i].classList.remove('hide');
      submenuOpenButtons[i].classList.add('hide');
      submenuCloseButtons[i].classList.remove('hide');
      submenuCloseButtons[i].focus();
    });
  });

  submenuCloseButtons.forEach((submenuCloseButton, i) => {
    submenuCloseButton.addEventListener('click', () => {
      submenus[i].classList.add('hide');
      submenuOpenButtons[i].classList.remove('hide');
      submenuOpenButtons[i].focus();
      submenuCloseButtons[i].classList.add('hide');
    });
  });
}

function mobileNavDisplays() {
  const displays = document.querySelectorAll('[data-mobile-menu-display]');
  const toggles = document.querySelectorAll('[data-open-menu-display]');
  const featuredHolder = document.querySelector('[data-feature-holder]');
  const featuredProducts = document.querySelectorAll('[data-mobile-featured-product]');
  const closeButton = document.querySelector('[data-drawer-close]');
  const backButton = document.querySelector('[data-back]');
  const bottomLinks = document.querySelectorAll('[data-bottom-link]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const targetString = toggle.getAttribute('data-open-menu-display');
      openDisplay(targetString);
    });
  });

  function openDisplay(targetString) {
    const target = document.querySelector(`[data-mobile-menu-display--${targetString}]`);
    if (!target) { return; }
    displays.forEach((display) => {
      display.classList.add('hide');
    });
    target.classList.remove('hide');
    setBottomLink(targetString);
    setDisplayElements(target);
  }

  function setBottomLink(targetString) {
    const bottomLinkTarget = document.querySelector(`[data-bottom-link--${targetString}]`);
    if (!bottomLinkTarget) { return; }
    bottomLinks.forEach((link) => {
      link.classList.add('hide');
    });
    bottomLinkTarget.classList.remove('hide');
  }

  function setDisplayElements(target) {
    if (target.getAttribute('data-collection-display') !== null && featuredProducts.length > 1) {
      featuredProducts[0].classList.add('hide');
      featuredProducts[1].classList.remove('hide');
      featuredHolder.classList.remove('hide');
    }

    if (target.getAttribute('data-product-display') !== null) {
      featuredProducts.forEach((featuredProduct) => {
        featuredProduct.classList.add('hide');
      });
      featuredHolder.classList.add('hide');
    }

    if (target.getAttribute('data-mobile-menu-display--main') === null) {
      closeButton.classList.add('hide');
      backButton.classList.remove('hide');
      backButton.setAttribute('data-open-menu-display', target.getAttribute('data-back-target'));
    } else {
      closeButton.classList.remove('hide');
      backButton.classList.add('hide');
      backButton.setAttribute('data-open-menu-display', '');
      featuredHolder.classList.remove('hide');
      if (featuredProducts.length > 0) {
        featuredProducts.forEach((featuredProduct) => {
          featuredProduct.classList.add('hide');
        });
        featuredProducts[0].classList.remove('hide');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  mobileNav();
  mobileNavDisplays();
});

// WIZARDS ONLY 

function wizardsOnly() {
  const siteBody = document.querySelector('[data-site-body]');
  const wizardsOnlyPopup = document.querySelector('[data-wizards-only]');
  const openButtons = document.querySelectorAll('[data-wizards-only-open]');
  const closeButton = document.querySelector('[data-wizards-only-close]');

  openButtons.forEach(button => {
    button.addEventListener('click', () => {
      wizardsOnlyPopup.classList.add('active');
      siteBody.classList.add('drawer-active');
      trapFocus(wizardsOnlyPopup);
    });
  });

  closeButton.addEventListener('click', closePopup);

  wizardsOnlyPopup.addEventListener('keydown', (event) => {
    if (event.keyCode !== 27) { return; }
    closePopup();
  });

  wizardsOnlyPopup.addEventListener('click', (event) => {
    if (typeof event.target.dataset.wizardsOnly !== 'string') { return; }
    closePopup();
  });

  function closePopup() {
    siteBody.classList.remove('drawer-active');
    wizardsOnlyPopup.classList.remove('active');
    removeTrapFocus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  wizardsOnly();
});

document.addEventListener('shopify:section:load', () => {
  wizardsOnly();
});


// YOTPO 

// Check if Yotpo is initialized
function yotpoSliderInit() {
  const reviewsWrapper = document.querySelector('[data-product-reviews]');
  const productReviews = document.querySelector('[data-product-template-reviews]');
  let mySwiper = null;
  const isProductTemplate = (productReviews !== null);

  const yotpoLoaded = setInterval(() => {
    const yotpoWrapper = document.querySelector('.main-widget');
    // If no reviews, add class and bail
    if (yotpoWrapper != null && yotpoWrapper.classList.contains('yotpo-no-reviews')) {
      reviewsWrapper.classList.add('no-reviews');
      clearInterval(yotpoLoaded);
      return;
    }

    // If reviews, make swiper, add click listener
    const yotpoReview = document.querySelector('.yotpo-review');
    if (yotpoReview !== null) {
      rejigLayout();
      rejigReviews();
      mySwiper = makeSwiper();
      disableSwiperOnDesktop();
      reviewLoadedChecker();
      clearInterval(yotpoLoaded);
    }
  }, 100);

  // Cancel interval if no reviews after 10 seconds
  setTimeout(() => {
    clearInterval(yotpoLoaded);
  }, 10000);

  function makeSwiper() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('swiper-container', 'reviews-slider');
    sliderContainer.setAttribute('data-product-reviews-swiper-container', '');
    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    sliderContainer.prepend(sliderWrapper);
    yotpoReviews.prepend(sliderContainer);

    initSwiper(sliderContainer);

    const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    if (yotpoReviewsList !== null) {
      const yotpoReviewArrays = [...yotpoReviewsList];
      yotpoReviewArrays.forEach((review) => {
        review.classList.add('swiper-slide');
        mySwiper.appendSlide(review);
      });
    }
    return mySwiper;
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: '.reviews-slider',
        invert: true,
      },
      navigation: {
        nextEl: '.swiper-nav__btn--next',
        prevEl: '.swiper-nav__btn--prev',
      },
    };

    mySwiper = new Swiper(sliderContainer, options);
  }

  function rejigLayout() {
    const bottomLine = reviewsWrapper.querySelector('.yotpo-bottomline');
    const yotopLabel = reviewsWrapper.querySelector('.yotpo-label');
    const yotopLabelClear = yotopLabel.querySelector('.yotpo-clr');
    const writeReviewButton = reviewsWrapper.querySelector('.write-review-button');
    const bottomLineEls = document.querySelectorAll('[data-yotpo-bottomline-container]');

    if (bottomLine == null) { return; }

    bottomLine.classList.remove('pull-left');
    writeReviewButton.classList.remove('pull-right');
    yotopLabelClear.remove();
    yotopLabel.appendChild(bottomLine);
    yotopLabel.appendChild(writeReviewButton);

    if (bottomLineEls == null) { return; }
    const bottomLineClone = bottomLine.cloneNode(true);
    bottomLineEls.forEach(bottomLineEl => {
      bottomLineEl.append(bottomLineClone);
    });
  }

  function rejigReviews() {
    const yotpoReviewsList = document.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    yotpoReviewsList.forEach(review => {
      const reviewHeader = review.querySelector('.yotpo-header');
      const reviewFooter = review.querySelector('.yotpo-footer');
      const reviewStars = review.querySelector('.yotpo-review-stars');
      const reviewStarsClone = reviewStars.cloneNode(true);
      const reviewName = review.querySelector('.yotpo-user-name');
      const reviewNameClone = reviewName.cloneNode(true);
      const reviewVerified = reviewHeader.querySelector('.label-with-tooltip');
      const reviewhelpfulLabel = review.querySelector('.label-helpful');

      if (reviewVerified !== null) {
        const reviewVerifiedClone = reviewVerified.cloneNode(true);
        reviewVerifiedClone.classList.add('verified-buyer');
        reviewFooter.prepend(reviewVerifiedClone);
        reviewVerified.remove();
      }
      reviewHeader.appendChild(reviewStarsClone);
      reviewFooter.prepend(reviewNameClone);

      reviewhelpfulLabel.innerText = 'Was This Helpful?';

      // Cleanup
      reviewName.remove();
      reviewStars.remove();
    });
  }

  function reviewLoadedChecker() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    document.querySelectorAll('.yotpo-page-element').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('yotpo-disabled')) {
          return;
        }
        yotpoReviews.style.visibility = 'hidden';
        const checkReviewsLoading = setInterval(() => {
          const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
          if (yotpoReviewsList != null && yotpoReviewsList.length > 0 && !yotpoReviewsList[0].classList.contains('swiper-slide')) {
            rejigReviews();
            mySwiper = makeSwiper();
            disableSwiperOnDesktop();
            yotpoReviews.style.visibility = 'visible';
            clearInterval(checkReviewsLoading);
            reviewLoadedChecker();
          }
        }, 50);
      });
    });
  }

  const breakpoint = window.matchMedia('(min-width: 750px)');
  breakpoint.addListener(disableSwiperOnDesktop);

  function disableSwiperOnDesktop() {
    if (!isProductTemplate) { return; }
    const swiperContainer = document.querySelector('[data-product-reviews-swiper-container]');
    if (swiperContainer === null) { return; }

    if (breakpoint.matches === true) {
      if (mySwiper !== null && typeof mySwiper !== 'undefined') {
        swiperContainer.classList.add('destroyed');
        mySwiper.destroy(true, true);
        mySwiper = null;
      }
    } else {
      initSwiper(swiperContainer);
      swiperContainer.classList.remove('destroyed');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  yotpoSliderInit();
});
